import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Enquiries & Assessments (the step before the Enquiry List).
 * API: /api/carehome-manager/care-enquiries
 */
const base = () => `/${getManagerRoutePath()}/care-enquiries`;

const careEnquiryService = {
  list: async () => (await axiosInstance.get(base())).data,
  get: async (id) => (await axiosInstance.get(`${base()}/${id}`)).data,
  create: async (payload) => (await axiosInstance.post(base(), payload)).data,
  startAssessment: async (id) => (await axiosInstance.post(`${base()}/${id}/start`)).data,
  sendInvite: async (id, payload) => (await axiosInstance.post(`${base()}/${id}/invite`, payload)).data,
  review: async (id, payload) => (await axiosInstance.post(`${base()}/${id}/review`, payload)).data,
  reopen: async (id) => (await axiosInstance.post(`${base()}/${id}/reopen`)).data,
  savePlan: async (id, payload) => (await axiosInstance.put(`${base()}/${id}/plan`, payload)).data,
  /** Autofill for the Convert form; data is null for residences not created by this flow. */
  getConvertPrefill: async (residenceId) =>
    (await axiosInstance.get(`${base()}/prefill/residence/${residenceId}`)).data,
};

export default careEnquiryService;
